// extracted by mini-css-extract-plugin
module.exports = {"DeletedTask":"styles_DeletedTask__2Y9J_"};